var ApplicationAPI = require("../../../../common/api").Application;
var ApplicantAPI = require("../../../../common/api").Applicant;
var RepositoryAPI = require("../../../../common/api").Repository;
var Config = require("../../../../common/api").Config;
var MessagesAPI = require("../../../../common/api").Messages;
var EvaluationAPI = require("../../../../common/api").Evaluation;
var OrganisationalTypesAPI = require("../../../../common/api")
  .OrganisationTypes;
var mapping = require("../../../../common/question-sets/mapping");
var enums = require("../../../../common/enums");

var _ = require("underscore");
var Promise = require("bluebird");

module.exports = function(
  $scope,
  $state,
  $interval,
  ngDialog,
  $stateParams,
  $window
) {
  var vm = this;
  vm.list = [];
  vm.attachments = [];
  vm.general = {
    showFullDetails: false,
    messageAttachments: []
  };

  vm.expectedReports = [];
  vm.selectedReportDetails = null;
  vm.conversations = [];
  vm.loading = false;
  vm.loadFailed = false;
  vm.isApplicantView = true; // enables editing of questions appropriately flagged
  vm.application = null;
  vm.fundsRaised = null;
  vm.selected = 0;

  vm.select = function(index) {
    vm.selected = index;
  };

  vm.applicationHistory = [];
  vm.applicationSupportingDocuments = [];

  var projectId = $stateParams.id;

  vm.doc_repos_url = window.conf.doc_repos_url;
  vm.encodeURIComponent = encodeURIComponent;
  vm.encodeDocumentId = function(id) {
    return encodeURIComponent(id.replace(/-/g, ""));
  };

  vm.uploadPublic = {};
  vm.uploadPrivate = {};

  vm.loading = true;
  vm.load = function() {
    if (!$stateParams.id) {
      throw new Error("no stateParams id");
      return;
    }
    var tasks = [
      getApplicationData(),
      ApplicationAPI.GetQuestions(projectId),
      ApplicationAPI.GetFundingOffers(
        projectId,
        "ApplicantFundingOfferView",
        2000,
        1
      ),
      ApplicantAPI.GetApplicantDetails(),
      vm.tickConversations(),
      ApplicationAPI.Get(projectId, "ApplicationFundsRaisedView")
    ];

    Promise.all(tasks).then(function(results) {
      if (!vm.loadFailed)
      {
        vm.questions = results[1];

        vm.questions.steps.forEach(function(step) {
          step.groups.forEach(function(group) {
            group.questions.forEach(function(question) {
              if (question.documentId !== undefined) {
                RepositoryAPI.GetRepoToken(question.documentId, false).then(
                  function(token) {
                    question.datalink = Config.docReposUrl() + question.datalink;
                    question.datalink += "?t=" + encodeURIComponent(token);
                  }
                );
              }
            });
          });
        });

        if (vm.questions && vm.questions.steps.length > 0) {
          vm.selected = vm.questions.steps[0];
        }

        vm.fundingOffers = results[2].results;
        for (var i = 0; i < vm.fundingOffers.length; i++) {
          vm.fundingOffers[i].showFullDetails = false;
        }

        vm.applicantId = results[3].applicantId;
        getApplicationHistory();

        vm.fundsRaised = results[5];
        var perc = Math.floor(
          (vm.fundsRaised.grandTotalRaised /
            (vm.fundsRaised.totalRequested +
              vm.fundsRaised.totalExternallyRaised)) *
            100
        );
        if (perc > 100) {
          vm.fundsRaised.percentage = 100;
        } else if (perc <= 0) {
          vm.fundsRaised.percentage = 0;
        } else {
          vm.fundsRaised.percentage = perc;
        }

        vm.fundsRaised.grantsTotal = 0;
        vm.fundsRaised.donationsTotal = 0;
        vm.fundsRaised.grants.forEach(function(grant) {
          vm.fundsRaised.grantsTotal += grant.grantAmount;
        });
        vm.fundsRaised.donations.forEach(function(donation) {
          vm.fundsRaised.donationsTotal += donation.total;
          donation.matches.forEach(function(match) {
            vm.fundsRaised.donationsTotal += match.total;
          });
        });
      };
      vm.loading = false;
    });

    vm.conversationId = "";
  };

  var getApplicationData = function() {
    return ApplicationAPI.Get(
      projectId,
      "ApplicationApplicantDashboardProjectView"
    ).then(function(result) {
      if ([20, 30, 50].includes(result.status.id))
      {
        vm.application = result;
        var perc = 0;
        if (vm.application.totalRaised > 0) {
          perc =
            (vm.application.totalRaised /
              (vm.application.totalRequested +
                vm.application.totalExternallyRaised)) *
            100;
        }

        vm.application.percentage = Math.floor(perc);
        ApplicationAPI.GetGeneralDocuments(projectId).then(function(appdocs) {
          vm.general.messageAttachments = appdocs;
        });
        vm.getExpectedReports();
        getSupportingDocuments();

      } else {
        vm.loadFailed = true;
      }
      return result;
    },
    function(result){
      vm.loadFailed = true;
    });
  };

  getApplication = function(applicationId) {
    return ApplicationAPI.Get(
      applicationId,
      "ApplicationApplicantDashboardProjectView"
    );
  };

  function getSupportingDocuments() {
    ApplicationAPI.GetSupportingDocuments(projectId).then(function(result) {
      vm.applicationSupportingDocuments = result;
    });
  }

  var getApplicationHistory = function() {
    return ApplicationAPI.GetApplicationHistory(
      projectId,
      "Applicant",
      vm.applicantId
    ).then(function(result) {
      vm.applicationHistory = result;
    });
  };

  vm.tickConversations = function() {
    return MessagesAPI.GetApplicationConversations($stateParams.id).then(
      function(result) {
        var promise;
        vm.conversations = result;
        // if no thread selected, and there are some results.
        if (!vm.currentThread && vm.conversations.length) {
          vm.currentThread = vm.conversations[0].conversationId;
        }

        if (vm.conversations.length > 0) {
          promise = MessagesAPI.GetApplicationMessageAttachments($stateParams.id);
          promise.then(
            function(mresult) {
              vm.attachments = mresult;
            }
          );
        }

        return promise;
      }
    );
  };
  $interval(vm.tickConversations, 60000);

  vm.changeConversation = function(id) {
    vm.currentThread = id;
  };

  vm.acceptTsandCs = function(offer) {
    var dialog = ngDialog.open({
      template: require("./dialogs/acceptTsandCs.pug")(),
      controller: require("./dialogs/acceptTsandCs.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      data: {
        fundingOfferFunder: offer.funder,
        termsDocumentType: offer.termsDocumentType
      }
    });

    dialog.closePromise.then(function(data) {
      if (data.value.action == "ok") {
        ApplicationAPI.AcceptFundingOffer(
          offer.id,
          !data.value.uploadSignedTermsDoc,
          data.value.uploadSignedTermsDoc,
          data.value.signedTermsDocument.id,
          data.value.signedTermsDocument.fileName,
          data.value.signedTermsDocument.fileSize,
          offer.termsDocumentType == 2
        ).then(function(result) {
          vm.load();
        });
      }
    });
  };

  vm.rejectFundingOffer = function(offerId) {
    var dialog = ngDialog.open({
      template: require("./dialogs/rejectOffer.pug")(),
      controller: require("./dialogs/rejectOffer.js"),
      plain: true,
      disableAnimation: true
    });

    dialog.closePromise.then(function(data) {
      if (data.value.action == "ok") {
        ApplicationAPI.RejectFundingOffer(
          offerId,
          data.value.rejectReason
        ).then(function(result) {
          vm.load();
        });
      }
    });
  };

  vm.addOrEditRaisedFundItem = function(item) {
    var clonedItem = {};
    if (item) {
      (clonedItem.id = item.id),
        (clonedItem.amount = item.amount),
        (clonedItem.organisation = item.organisation),
        (clonedItem.grantPaid = item.grantPaid),
        (clonedItem.receivedOn = item.receivedOn),
        (clonedItem.grantExpected = item.grantExpected),
        (clonedItem.anySpecialConditions = item.anySpecialConditions),
        (clonedItem.specialConditions = item.specialConditions);
    }
    var dialog = ngDialog.open({
      template: require("./dialogs/raised-fund-item.pug")(),
      controller: require("./dialogs/raised-fund-item.js"),
      plain: true,
      disableAnimation: true,
      data: {
        raisedFundItem: clonedItem,
        create: function(clonedItem) {
          return ApplicationAPI.CreateRaisedFundItem(projectId, clonedItem);
        },
        update: function(clonedItem) {
          return ApplicationAPI.UpdateRaisedFundItem(projectId, clonedItem);
        },
        del: function(clonedItem) {
          return ApplicationAPI.RemoveRaisedFundItem(projectId, clonedItem.id);
        }
      }
    });

    dialog.closePromise.then(function(data) {
      if (data.value.action !== "ok") return;
      vm.load();
    });
  };

  vm.updateStep = function(form, step) {
    vm.loading = true;
    var mapped = mapping.mapStepToRequest(JSON.parse(JSON.stringify(step)));

    // prompt: notify funder too?
    ngDialog
      .open({
        template: require("./dialogs/confirmation.pug")(),
        controller: require("./dialogs/confirmation.js"),
        controllerAs: "vm",
        plain: true,
        disableAnimation: true,
        className: "ge-dialog-medium ngdialog-theme-default",
        data: {
          okLabel: "Finish now",
          cancelLabel: "Finish later",
          message:
            "Would you like to finish now and notify the funder, or finish and notify the funder later?"
        }
      })
      .closePromise.then(function(data) {
        var notify = data.value.action == "ok";

        // make the call
        ApplicationAPI.UpdateStep(projectId, step.id, mapped, notify).then(
          function() {
            form.$setPristine();
            vm.loading = false;

            // inform user it's all good
            ngDialog.open({
              template: require("./dialogs/confirmation.pug")(),
              controller: require("./dialogs/confirmation.js"),
              controllerAs: "vm",
              plain: true,
              disableAnimation: true,
              className: "ge-dialog-medium ngdialog-theme-default",
              data: {
                okOnly: true,
                message: notify
                  ? "Answers saved and funder notified."
                  : "Answers saved."
              }
            });
          },
          function() {
            vm.loading = false;
            alert(
              "There was a problem updaing your application.  Please try again."
            );
          }
        );
      });
  };

  vm.openFunderPage = function(funderId) {
    window.open("/funders/" + funderId);
  };

  vm.resetToDraft = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/resetToDraft.pug")(),
      controller: require("./dialogs/resetToDraft.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true
    });
    dialog.closePromise.then(function(data) {
      if (data.value.action == "ok") {
        ApplicationAPI.ResetToDraft(projectId, data.value.reason).then(
          function() {
            window.location = "/applicant/dashboard/projects";
          }
        );
      }
    });
  };

  vm.requestEdit = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/requestEdit.pug")(),
      controller: require("./dialogs/requestEdit.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true
    });
    dialog.closePromise.then(function(data) {
      if (data.value.action == "ok") {
        ApplicationAPI.RequestEdit(projectId, data.value.reason).then(
          function() {
            window.location = "/applicant/dashboard/projects";
          }
        );
      }
    });
  };

  vm.addApplicationNote = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/note.pug")(),
      controller: require("./dialogs/note.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default"
    });

    dialog.closePromise.then(function(data) {
      if (data.value.action == "save") {
        ApplicationAPI.CreateApplicationNote(projectId, {
          organisationId: vm.applicantId,
          type: "Applicant",
          text: data.value.note
        }).then(function() {
          getApplicationHistory();
        });
      }
    });
  };

  vm.startOrSelectReport = function(report) {
    //do some report stuff here
    vm.expectedReports.forEach(function(exrep) {
      if (exrep.reportId != report.reportId) {
        exrep.showReport = false;
      }
    });
    if (report.isStarted == false) {
      //call start API method here
      report.isStarted = true;
      EvaluationAPI.StartEvaluationReport(report.reportId).then(function() {
        vm.getReportDetails(report);
      });
    } else {
      vm.getReportDetails(report);
    }
    report.showReport = true;
  };

  vm.getExpectedReports = function() {
    //get report labels.. same as admin method
    EvaluationAPI.GetEvaluationReportLabels($stateParams.id).then(function(
      result
    ) {
      vm.expectedReports = result;
      vm.expectedReports.forEach(function(rep) {
        rep.showReport = false;
      });
    });
  };

  vm.getReportDetails = function(report) {
    EvaluationAPI.GetEvaluationReportDetails(report.reportId).then(function(
      results
    ) {
      vm.selectedReportDetails = results;
    });
  };

  vm.updateReport = function(report) {
    var tasks = [];
    if (report.breakdownCosts) {
      report.breakdownCosts.forEach(function(costItem) {
        tasks.push(EvaluationAPI.UpdateEvalutionReportBreakdownCost(costItem));
      });
    }

    tasks.push(EvaluationAPI.UpdateEvalutionReport(report));

    Promise.all(tasks)
      .then(function(results) {
        vm.getReportDetails(vm.selectedReportDetails);
      })
      .then(function() {
        vm.getReportDetails(report);
      });
  };

  vm.updateBreakdownCostItems = function(report) {
    var tasks = [];
    report.breakdownCosts.forEach(function(costItem) {
      tasks.push(EvaluationAPI.UpdateEvalutionReportBreakdownCost(costItem));
    });
  };

  vm.addNewEvaluationReportDocument = function(isPublic) {
    if (vm.selectedReportDetails) {
      //add to docrepos
      //save to database
      var upload = isPublic ? vm.uploadPublic : vm.uploadPrivate;
      vm.addFileDetails(upload, isPublic);
    }
  };

  vm.removeEvaluationReportDocument = function(reportDocument) {
    //remove from database
    var documents = reportDocument.isPublic
      ? vm.selectedReportDetails.publicDocuments
      : vm.selectedReportDetails.privateDocuments;
    EvaluationAPI.RemoveReportDocument(reportDocument).then(function() {
      var index = documents.indexOf(reportDocument);
      if (index > -1) {
        documents.splice(index, 1);
      }
    });
  };

  vm.submitForApproval = function($event, tab) {
    $event.stopPropagation();
    EvaluationAPI.SubmitForApproval(
      vm.selectedReportDetails.reportId,
      tab
    ).then(function() {
      vm.getReportDetails(vm.selectedReportDetails);
    });
  };

  vm.cancelSubmitApproval = function($event, tab) {
    $event.stopPropagation();
    EvaluationAPI.CancelSubmitForApproval(
      vm.selectedReportDetails.reportId,
      tab
    ).then(function() {
      vm.getReportDetails(vm.selectedReportDetails);
    });
  };

  vm.load();

  vm.aimsAndObjectivesTextP1 =
    "Please tell us whether you completed all of the aims and objectives you set out to achieve for your project and" +
    " briefly how you achieved them.  We would like to help other applicants who are embarking on a similar project with advice and your experience" +
    " will be invaluable in enabling us to do this. If you didn't achieve everything you set out to achieve we would like to hear how you think you" +
    " may have been able to improve so that we can advise others.";

  vm.aimsAndObjectivesTextP2 =
    'You need to provide evidence of the aims and objectives you recorded in the "what do you aim to achieve and how' +
    ' will you measure this " section of the application.  For example, if you were raising money to employ a youth worker and you put on your' +
    " application form that you want to achieve a youth club membership of 40 in the first six months you need to say (and provide evidence for)" +
    " how many members you actually signed up.  If you already have this information in report format you can upload it as a Public Document (if you" +
    " wish anybody to see it) or as a Private Document (in which case only you, The Good Exchange and organisations that funded you can see it)";

  vm.benefitsAndEvidence =
    "For example, if your grant was to employ a youth worker you need to provide evidence such as: What are the benefits of the work they have achieved to date (or what they plan to achieve). How many youth club members have they signed up? How many volunteers have they employed? How many training schemes have they set up? How much has crime or anti-social behaviour reduced since they have been in post? What Sports/Cultural/Educational and Training activities are now available to young people? It may also be useful to upload a report in the Public Documents section.";

  vm.projectCostsP1 =
    "The cost breakdown items below have been extracted from your application. You will need to confirm the actual costs in the column provided and provide a comment next to the actual cost. For example, if the actual cost was the same as the budgeted cost say so. If the actual cost was different please explain why and if the budgeted item was no longer required, please put zero in the actual cost and explain why it wasn’t required. Each line item must have a value entered into the actual cost column and have a brief description in the comments column or your report will not save. We recommend that you save your financial report in draft first, go back and read it through to make sure it has saved correctly. Once you are happy with the content please submit it. Once submitted it will be viewable to grant makers and members of the public. ";
  vm.projectCostsP2 =
    "Any application which has received a grant must have copies of receipts or invoices attached, which can be uploaded in the Private Documents section (these are confidential and so should NOT be uploaded in Public Documents). You may upload as many documents as necessary.";

  vm.downloadPublicFile = function(document) {
    var formattedId = document.documentId.replace(/-/g, "");
    var url =
      window.conf.doc_repos_url +
      "get/" +
      encodeURIComponent(formattedId) +
      "/" +
      document.fileName;

    //download file here (opens in new tab)
    $window.open(url, "_blank");
  };

  vm.downloadPrivateFile = function(document) {
    RepositoryAPI.GetRepoToken(document.documentId, false, true).then(function(
      token
    ) {
      var formattedId = document.documentId.replace(/-/g, "");
      var url =
        window.conf.doc_repos_url +
        "dl/" +
        encodeURIComponent(formattedId) +
        "/" +
        document.fileName +
        "?t=" +
        encodeURIComponent(token);

      //download file here (opens in new tab)
      $window.open(url, "_blank");
    });
  };

  vm.downloadDocument = function(document) {
    RepositoryAPI.GetRepoToken(document.blobId, false, true).then(function(
      token
    ) {
      var formattedId = document.blobId.replace(/-/g, "");
      var url =
        window.conf.doc_repos_url +
        "dl/" +
        encodeURIComponent(formattedId) +
        "/" +
        document.fileName +
        "?t=" +
        encodeURIComponent(token);

      //download file here (opens in new tab)
      $window.open(url, "_blank");
    });
  };

  vm.downloadFundingDocument = function(blobId, fileName) {
    var doc = {};
    doc.blobId = blobId;
    doc.fileName = fileName;
    vm.downloadDocument(doc);
  };

  vm.addFileDetails = function(upload, isPublic) {
    var dialog = ngDialog.open({
      template: require("./dialogs/fileComment.pug")(),
      controller: require("./dialogs/fileComment.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default"
    });

    dialog.closePromise.then(function(data) {
      if (data.value.action == "save") {
        var details = data.value.fileDetails;
        var fileExt = upload.fileName.split(".").pop();
        var filename =
          details.fileName.length > 0
            ? details.fileName + "." + fileExt
            : upload.fileName;
        var document = {
          applicationEvaluationReportId: vm.selectedReportDetails.reportId,
          blobId: upload.id,
          fileName: filename,
          fileSize: upload.fileSize,
          isPublic: isPublic,
          comment: details.comment
        };
        EvaluationAPI.AddReportDocument(document).then(function() {
          vm.uploadPublic = null;
          vm.uploadPrivate = null;
          vm.getReportDetails(vm.selectedReportDetails);
        });
      }
    });
  };

  vm.markSuccessful = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/markSuccessful.pug")(),
      controller: require("./dialogs/markSuccessful.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true,
      data: {
        message:
          "By taking this action you are confirming that you are satisfied that you have raised enough money to carry out a significant part, if not all, of your project.  You will then need to start compiling your Evaluation report, which will significantly increase your chances of obtaining future funding for other projects.  Are you sure you wish to set the project status to Successful?"
      }
    });
    dialog.closePromise.then(function(data) {
      if (data.value.action == "ok") {
        var req = {};
        req.status = 50;
        req.comment = "Applicant marked the project as Successful";
        ApplicationAPI.SetStatus(vm.application.id, req).then(function(result) {
          vm.load();
        });
      }
    });
  };

  vm.removeApplicationSupportingDocument = function(doc) {
    //remove from database
    ApplicationAPI.RemoveSupportingDocument(projectId, doc.id).then(function() {
      getSupportingDocuments();
    });
  };

  vm.addSupportingDocument = function() {
    var dialog = ngDialog.open({
      template: require("./dialogs/fileComment.pug")(),
      controller: require("./dialogs/fileComment.js"),
      controllerAs: "vm",
      plain: true,
      disableAnimation: true,
      className: "ge-dialog-medium ngdialog-theme-default",
      data: {
        editFilename: false,
        fileName: vm.appSupportingDocUpload.fileName
      }
    });

    dialog.closePromise.then(function(data) {
      if (data.value.action == "save") {
        var uploadDetails = vm.appSupportingDocUpload;
        var details = data.value.fileDetails;
        var fileExt = uploadDetails.fileName.split(".").pop();
        var filename =
          details.fileName.length > 0
            ? details.fileName
            : uploadDetails.fileName;
        var document = {
          applicationId: projectId,
          blobId: uploadDetails.id,
          fileName: filename,
          fileSize: uploadDetails.fileSize,
          isPublic: false,
          comment: details.comment
        };
        ApplicationAPI.AddSupportingDocument(document).then(function() {
          vm.appSupportingDocUpload = null;
          getSupportingDocuments();
        });
      }
    });
  };

  function getSupportingDocuments() {
    ApplicationAPI.GetSupportingDocuments(projectId).then(function(result) {
      vm.applicationSupportingDocuments = result;
    });
  }

	vm.MatchedContributionText = function(matchFundingRules, offer){
		var textToShow = (offer.grantRoundContributionRate * 100) + "% of matched donations ";
		if(matchFundingRules.endEvent == 'SpecifiedAmountOrDate' || matchFundingRules.endEvent == 'SpecifiedAmountDonated')
		{
			textToShow += ", up to a maximum of " +
			new Intl.NumberFormat('en-GB', {  style: 'currency', currency: 'GBP' }).format(matchFundingRules.specifiedAmountDonated * offer.grantRoundContributionRate);
		}
		return textToShow;
	};
};
